exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#map{\n    top:100px;\n    width:100%;\n    height:600px;\n    background-color: rgb(255, 255, 255);\n    position:absolute;\n    border-radius:5px;\n    overflow:hidden;\n    /* box-shadow: 5px 5px 5px #888; */\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/map/map.component.css
// module id = ../../../../../src/app/components/map/map.component.css
// module chunks = main